<template>
  <div class="create-link">
    <div
      v-if="selectedLink"
      class="create-link__title"
    >
      Edit Link
    </div>
    <div
      v-else
      class="create-link__title"
    >
      Create New Link
    </div>
    <div class="section">
      <label class="create-link__input">
        <span class="create-link__label">Link Type</span>
        <div
          class="create-link__link-wrapper"
          :class="{'create-link__link-wrapper_single': isDomainDropdownHidden}"
        >
          <base-select
            v-model="link.link_type_id"
            :border-less="true"
            class="create-link__link-type"
            :options="opts.category_id_opts"
            :align-left="true"
            :max-height-list="450"
            :title-style="titleStyle"
            :header-style="selectTypeStyle"
          />
        </div>
      </label>
      <label class="create-link__input">
        <span class="create-link__label">Status</span>
        <div
          class="create-link__link-wrapper"
          :class="{'create-link__link-wrapper_single': isDomainDropdownHidden}"
        >
          <base-select
            v-model="link.status_id"
            :border-less="true"
            class="create-link__status"
            :options="opts.status_id_opts"
            :align-left="true"
            :max-height-list="450"
            :title-style="titleStyle"
            :header-style="selectTypeStyle"
          />
        </div>
      </label>
      <label class="create-link__input">
        <span class="create-link__label">URL</span>
        <div
          class="create-link__link-wrapper"
          :class="{'create-link__link-wrapper_single': isDomainDropdownHidden}"
        >
          <base-select
            v-model="link.fk_url_id"
            is-smart-input
            :border-less="true"
            class="create-link__url"
            :options="opts.url_id_opts"
            :align-left="true"
            :max-height-list="450"
            :title-style="titleStyle"
            :header-style="selectTypeStyle"
          />
        </div>
      </label>
    </div>
    <div class="section">
      <label class="create-link__input">
        <span class="create-link__label">Page Title</span>
        <div
          class="create-link__link-wrapper"
          :class="{'create-link__link-wrapper_single': isDomainDropdownHidden}"
        >
          <input
            v-model="link.link_page_title"
            type="text"
            class="form-control create-link__link-field"
          >
        </div>
      </label>
      <label class="create-link__input">
        <span class="create-link__label">Anchor Text</span>
        <div
          class="create-link__link-wrapper"
          :class="{'create-link__link-wrapper_single': isDomainDropdownHidden}"
        >
          <input
            v-model="link.link_anchor_text"
            type="text"
            class="form-control create-link__link-field"
          >
        </div>
      </label>
      <label class="create-link__input">
        <span class="create-link__label">Publisher URL</span>
        <div
          class="create-link__link-wrapper"
          :class="{'create-link__link-wrapper_single': isDomainDropdownHidden}"
        >
          <input
            v-model="link.publisher_url"
            type="text"
            class="form-control create-link__link-field"
          >
          <span
            v-if="externalErrors.publisher_url"
            class="create-link__error-message"
          >{{ externalErrors.publisher_url }}</span>
        </div>
      </label>
      <div class="create-link__date-wrapper">
        <base-date-picker-button
          v-model="link.publish_date"
          class="create-link__date"
        >
          <div class="create-link__date-title">
            Publish Date
          </div>
        </base-date-picker-button>
      </div>
      <label class="create-link__input">
        <span class="create-link__label">DA</span>
        <div
          class="create-link__link-wrapper"
          :class="{'create-link__link-wrapper_single': isDomainDropdownHidden}"
        >
          <input
            v-model="link.domain_authority"
            type="text"
            class="form-control create-link__link-field"
          >
        </div>
      </label>
      <label class="create-link__input">
        <span class="create-link__label">TF</span>
        <div
          class="create-link__link-wrapper"
          :class="{'create-link__link-wrapper_single': isDomainDropdownHidden}"
        >
          <input
            v-model="link.trust_flow"
            type="text"
            class="form-control create-link__link-field"
          >
        </div>
      </label>
    </div>
    <div class="create-link__controls">
      <button
        class="create-link__button create-link__button_cancel"
        @click.prevent="close()"
      >
        Cancel
      </button>
      <button
        v-if="selectedLink"
        class="create-link__button create-link__button_delete"
        @click.prevent="deleteLink()"
      >
        Delete
      </button>
      <button
        class="create-link__button create-link__button_submit"
        @click.prevent="apply()"
      >
        Apply
      </button>
    </div>
    <div
      v-if="link.id"
      class="section"
      style="margin-top: 10%;"
    >
      <table style="width:100%;border-collapse:collapse;">
        <tr>
          <th>File Attachment</th>
        </tr>
        <tr class="tr-add-attachment">
          <td>
            <div
              class="create-link__link-wrapper"
              :class="{'create-import__link-wrapper_single': isDomainDropdownHidden}"
            >
              <input
                type="file"
                @change="fileChange($event.target.files[0])"
              >
            </div>
          </td>
          <td>
            <label class="create-link__input">
              <div
                class="create-link__link-wrapper"
                :class="{'create-link__link-wrapper_single': isDomainDropdownHidden}"
              >
                <base-select
                  v-model="attachmentCategoryId"
                  :border-less="true"
                  class="create-link__attachment"
                  :options="opts.attachment_category_id_opts"
                  :align-left="true"
                  :max-height-list="450"
                  :title-style="titleStyle"
                  :header-style="selectTypeStyle"
                />
              </div>
            </label>
          </td>
          <td>
            <button
              class="create-link__button create-link__button_submit"
              @click.prevent="applyAttachment()"
            >
              Add
            </button>
          </td>
        </tr>
        <tr
          v-for="(attachment, i) in attachments"
          :key="i"
        >
          <td>
            <span
              v-tooltip.bottom-start="{content: 'Click to download', ...tooltipOptions}"
              class="create-link__attachment-link"
              @click="downloadAttachment(attachment.file_id)"
            >
              {{ attachment.filename }}
            </span>
          </td>
          <td>{{ attachment.link_attachment_category }}</td>
          <td>
            <button
              v-if="selectedLink"
              class="create-link__button create-link__button_delete"
              @click.prevent="deleteAttachment(attachment.id)"
            >
              Delete
            </button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import BaseModalMixins from '@/common/BaseModalMixins'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline'
}
const ACTIVE_OPTIONS = [
  {
    label: 'Yes',
    value: 1
  },
  {
    label: 'No',
    value: 0
  }
]
export default {
  name: 'CreateUpdateLinkPopup',
  mixins: [BaseModalMixins],
  props: {
    selectedLink: {
      type: Object
    },
    opts: {
      type: Object,
      required: true
    },
    attachments: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      link: _.cloneDeep(this.selectedLink) || {
        status_id: -1,
        state: -1,
        link_type_id: -1,
        fk_url_id: -1,
        is_active: 1,
        client_invoice: null,
        client_sow: null,
        agent: null,
        agent_order_record: null,
        agent_assignment_date: null,
        agent_target_date: null,
        link_page_title: null,
        link_anchor_text: null,
        publisher_url: null,
        domain_authority: null,
        trust_flow: null,
        citation_flow: null,
        tf_ratio: null
      },
      attachment: null,
      attachmentCategoryId: -1,
      externalErrors: {
        name: null,
        publisher_url: null
      },
      tooltipOptions: {
        delay: { show: 100, hide: 100 },
        classes: 'rfx-tooltip'
      },
      isValidating: false,
      // should domain name selector be hidden or not
      isDomainDropdownHidden: true,
      elementStyle: {},
      titleStyle: {
        overflow: 'visible'
      },
      activeOpts: _.cloneDeep(ACTIVE_OPTIONS),
      selectTypeStyle: _.cloneDeep(SELECT_STYLE)
    }
  },
  methods: {
    /**
     * Handling decline creating new URL & hiding component
     */
    close () {
      this.$emit('cancel')
    },
    convertToOptions (item) {
      return {
        value: item._id,
        label: item.label
      }
    },
    showErrors (errors) {
      for (const k in this.externalErrors) {
        this.externalErrors[k] = null
      }

      for (const k in errors) {
        this.externalErrors[k] = errors[k]
      }
    },
    apply () {
      const convertToString = (date) => {
        return date
          ? moment(date).format('YYYY-MM-DD')
          : null
      }
      const link = _.cloneDeep(this.link)
      link.agent_assignment_date = convertToString(link.agent_assignment_date)
      link.agent_target_date = convertToString(link.agent_target_date)
      link.publish_date = convertToString(link.publish_date)
      this.$emit('apply', link)
    },
    applyAttachment () {
      const form = new FormData()
      if (this.attachment) {
        form.append('attachment', this.attachment, this.attachment.name)
        form.append('attachment_category_id', this.attachmentCategoryId)
        form.append('link_id', this.link.id)
        this.$emit('applyAttachment', form)
      }
    },
    fileChange (file) {
      this.attachment = file
    },
    deleteLink () {
      this.$emit('delete', this.link.id)
    },
    deleteAttachment (id) {
      this.$emit('deleteAttachment', id)
    },
    async downloadAttachment (id) {
      this.$emit('downloadAttachment', id)
    }
  }
}
</script>

<style lang="scss" scoped>
.create-link {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 40px;

  &__title {
    text-align: center;
    font-size: 34px;
    font-weight: 500;
    margin: 9px 0 35px;
    color: $rfx-dark-march;
  }

  &__input {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: 30px;

    &_invalid[type='text'] {
      border: 1px solid $rfx-red;
      border-radius: 4px;
    }
  }

  &__label {
    display: block;
    font-weight: 600;
    margin-bottom: 5px;
    color: $rfx-dark-march;
  }

  &__controls {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }

  &__button {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    margin-left: 30px;
    border: none;
    outline: none;
    cursor: pointer;

    &_submit {
      background-color: $rfx-medium-march;
      color: #fff;

      &:disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }
    }

    &_delete {
      background-color: $rfx-red;
      color: #fff
    }

    &_disabled {
      pointer-events: none;
      background-color: #fff;
      color: $rfx-neutral-grey;
      cursor: default;
    }

    &_cancel {
      color: $rfx-dark-march;
      background-color: #fff;
    }
  }

  &__link {
    &-wrapper {
      position: relative;
      margin-top: 30px;

      &_single {
        margin-top: 0;
      }
    }

    &-field[type='text'] {
      width: 100%;
      box-sizing: border-box;
      padding-right: 60px;
      font-weight: 500;
      @include ellipsis;
    }
  }

  &__error-message {
    color: $rfx-red;
    font-size: 10px;
    margin-top: 5px;
  }

  &__date-wrapper {
    display: flex;
    font-weight: bold;
  }

  &__date {
    flex: 0 0 30%;
    color: $rfx-dark-march;

    &_error {
      color: $rfx-red;
    }
  }

  &__attachment-link {
    flex: 1 1;
    padding-left: 15px;
    @include ellipsis;
    text-decoration: none;
    color: $rfx-bright-blue;
    cursor: pointer;
  }

}

.form-control {
  height: 50px;
  padding: 0 20px;
  border: 2px solid $rfx-light-steel;
  outline: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: $rfx-dark-march;

  &::placeholder {
    color: $rfx-pearl;
    font-weight: normal;
    font-size: 14px;
  }

  &:disabled {
    background-color: $rfx-light-steel;
  }

  &_error {
    border-color: $rfx-red;
    color: $rfx-red;

    &::placeholder {
      color: $rfx-red;
      font-size: 13px;
    }

  }
}

.section {
  background-color: $rfx-grey;
  margin: 10px;
  padding: 10px;
  border-radius: 5px;
}

.tr-add-attachment td {
  border-bottom: 2px solid $rfx-dark-grey;
}

</style>
